/**
 * Pure feature-flag resolution helper. Lives in its own module so
 * unit tests can import it without dragging in react-router-dom or
 * any other React-only deps.
 */
export function resolveFeatureFlags(activeWorkspace) {
  const flags = (activeWorkspace && activeWorkspace.feature_flags) || {};
  return {
    ukWorkflows: flags.uk_workflows !== false,   // defaults ON
    euLane:      flags.eu_lane === true,         // defaults OFF
    // Phase 6 (Feb 2026) — shared claim pack builder pilot.
    // Defaults OFF; system_admin flips per workspace.
    euClaimPackBuilderV2: flags.eu_claim_pack_builder_v2 === true,
    raw: flags,
  };
}
